import React, { useEffect, useState, useContext, useCallback, useRef, useMemo } from 'react'
import DocTagsService from '../../components/utils/docTags.service'
import GroupIcon from '@mui/icons-material/Group'
import TableCustomOffice from '../../components/utils/tableCustomOffice'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import Draggable from 'react-draggable'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Splitter, SplitterPanel } from 'primereact/splitter'
import './createBL.css'
import { saveAs } from 'file-saver'
import jsPDF from 'jspdf'
import { PDFDocument } from 'pdf-lib'
import { Download as DownloadIcon, Anchor, Settings } from '@mui/icons-material'
import download from 'downloadjs'
import PostAddIcon from '@mui/icons-material/PostAdd'

import { M_ElementDrawer as MElementDrawer, M_Button as MButton, M_CheckBox as MCheckBox, M_InputTextField as MInputTextField, M_TextArea as MTextArea, M_SwitchButton as MSwitchButton, LoadingContext, LoadingBar, BufferService, M_Header as MHeader, NavigateContext, M_TimeLine as MTimeLine, M_TabsInpage as MTabsInpage, M_Fieldset as MFieldset, M_MessageBoard as MMessageBoard, M_Select as MSelect } from 'src/M_Components' 

export default function ViewBL({ handleTabClose, toastMessages }) {
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()
    const matches = useMediaQuery('(min-width:1200px)')

    const [leavingPage, setLeavingPage] = useState(false)

    const entityLabels = [
        {
            label: 'Shipper',
            fields: ['Name', 'Address', 'Address2', 'ZipCode', 'Country', 'Vat']
        },
        {
            label: 'Consignee',
            fields: ['Name', 'Address', 'Address2', 'ZipCode', 'Country', 'Vat']
        },
        {
            label: 'Notify',
            fields: ['Name', 'Address', 'Address2', 'ZipCode', 'Country', 'Vat']
        },
    ]

    const portsLocations = [
        { label: 'Original Port', tablecode: 'Name', type: 'textfield', code: 'voyagePlaceReceipt', id: 'LocationReceiptId', name: 'LocationReceiptPortName' },
        { label: 'Loading Port', tablecode: 'Name', type: 'textfield', code: 'voyagePortLoading', id: 'LoadingPortId', name: 'LocationLoadingPortName' },
        { label: 'Discharge Port', tablecode: 'Name', type: 'textfield', code: 'voyagePortDischarge', id: 'DischargePortId', name: 'LocationDischargePortName' },
        { label: 'Final Port', tablecode: 'Name', type: 'textfield', code: 'voyagePlaceDelivery', id: 'LocationDeliveryPortId', name: 'LocationDeliveryPortName' },
        { label: 'Transhipment', tablecode: '', type: 'checkbox', code: 'Transhipment', name: 'Transhipment' },
    ]

    const Commmodity = [
        { label: 'Code', type: 'textfield', code: 'CommodityCode' },
        { label: 'Name', type: 'textfield', code: 'CommodityName' },            //! FALTA AUDITION NESTE COMPONENT!!!!
    ]

    //*document
    const [blHTML, setBlHTML] = useState()
    const [blHTMLCopy, setBlHTMLCopy] = useState()

    const [blSecondHTML, setBlSecondHTML] = useState()
    const [blSecondHTMLCopy, setBlSecondHTMLCopy] = useState()

    //* tag building states
    const [varNameDict, setVarNameDict] = useState(new Map())

    //* options menu
    const [formPorts, setFormPorts] = useState(false)
    const [formEntities, setFormEntities] = useState(true)
    const [formCustomOffice, setFormCustomOffice] = useState(false)
    const [formShipmentDetails, setFormShipmentDetails] = useState(false)

    const [customOfficeDict, setCustomOfficeDict] = useState(new Map())
    const [dictCustomOfficeDict, setDictCustomOFficeDict] = useState([])

    const [showInput, setShowInput] = useState(false)
    const [zoom, setZoom] = useState(50)
    const [page, setPage] = useState(1)
    const [lines, setLines] = useState(0)
    const [docSize, setDocSize] = useState(2)
    const [pageSize, setPageSize] = useState(10)
    const [auxPageSize, setAuxPageSize] = useState(35)

    const [organizedData, setOrganizedData] = useState(new Map())
    const [containerTypes, setContainerTypes] = useState([])
    
    const [totalIds, setTotalIds] = useState(1)
    const [shipmentIndex, setShipmentIndex] = useState(1)
    const [separator, setSeparator] = useState([55, 45])
    const [listErrors, setListErrors] = useState('')
    const [OpenModalSeeErrors, setOpenModalSeeErrors] = useState(false)




    const docTagsServiceRef = useRef(null)
    if (!docTagsServiceRef.current) {
        docTagsServiceRef.current = new DocTagsService()
    }

    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const [isFirstIteration, setIsFirstIteration] = useState(true)
    const [isLoaded, setIsLoaded] = useState(true)
    const lineId = JSON.parse(sessionStorage.getItem('blContext')) ? JSON.parse(sessionStorage.getItem('blContext')).Id : null
    const BLService = new BufferService('viewbl')
    const auditService = new BufferService('audit/lastbl')
    const ProcessStatusService = new BufferService('processStatus')
    const errorList = new BufferService('viewblerrors')


    const [downloadablePDF, setDownloadablePDF] = useState(false)
    const [changesTabs, setChangesTabs] = useState([])

    const sessionKeys = ['formEntities', 'formCustomOffice', 'formShipmentDetails', 'blHTMLCopy', 'blSecondHTMLCopy',
        'varNameDict', 'customOfficeDict', 'dictCustomOfficeDict', 'showInput', 'bookingDate', 'BLDate',
        'lines', 'docSize', 'pageSize', 'auxPageSize', 'organizedData', 'containerTypes', 'totalIds', 'shipmentIndex',
        'page', 'approveDate', 'containerDate', 'formPorts', 'changesTabs', 'downloadablePDF', 'listErrors'
    ]

    const [bookingDate, setBookingDate] = useState("")
    const [BLDate, setBLDate] = useState("")
    const [approveDate, setApproveDate] = useState("")
    const [containerDate, setContainerDate] = useState("")

    const [openElement, setOpenElement] = useState(false)
    const [shipmentToDispatch, setShipmentToDispatch] = useState(null)

    const cards = [
        { id: 4, name: 'Ports', code: 'Ports', icon: <Anchor className='iconCard' /> },
        { id: 1, name: t("Entities"), code: 'Entities', icon: <GroupIcon className='iconCard' /> },
        { id: 2, name: 'Custom Office', code: 'CustomOffice', icon: <PostAddIcon className='iconCard' /> },
        { id: 3, name: 'Shipment Details', code: 'ShipmentDetails', icon: <i className="pi pi-box" ></i> },
    ]

    const valueTimeline = [
        { icon: 'pi pi-circle-fill', name: t("TimeLineCreatBook"), color: 'white', connectorColor: 'var(--color-blue)', date: bookingDate },
        { icon: 'pi pi-circle-fill', name: t("TimeLineBookAccp"), color: 'white', connectorColor: 'var(--color-blue)', date: approveDate },
        { icon: 'pi pi-circle-fill', name: t("TimeLineInsCont"), color: 'white', connectorColor: 'var(--color-blue)', date: containerDate },
        { icon: 'pi pi-circle-fill', name: t("TimeLineCreBL"), color: 'white', connectorColor: 'var(--color-blue)', date: BLDate },
        { icon: 'pi pi-spin pi-spinner', name: t("TimeLineBLAccep"), color: 'White', connectorColor: 'var(--color-blue-light)', date: '' }
    ]

    const DangerousGoods = [
        { label: 'UN No.', type: 'textfield', code: 'DangerousGoodsCode' },
        { label: 'Class', type: 'textfield', code: 'DangerousGoodsClass' },
        { label: 'Flash Point(ºC)', type: 'number', code: 'FlashPT' },
        { label: 'Package Group', type: 'textfield', code: 'PackagingGroup' },
    ]

    const BLCustomsOfficeFields = [
        { webtrans: 'CustomsOfficeId', backend: 'Id' },
        { webtrans: 'Document Type', backend: 'PCOMCustomsDocumentTypeDesc' },
        { webtrans: 'Despatch number', backend: 'PCOMCustomsDocumentNumber' },
        { webtrans: 'Customs office', backend: 'PCOMCustomsOffice' },
        { webtrans: 'Date', backend: 'PCOMCustomsDocumentDate' },
    ]

    const BLFields = [
        { webtrans: 'voyagePortDischarge', backend: 'DischargePort' },
        { webtrans: 'voyagePortLoading', backend: 'LoadingPort' },
        { webtrans: 'voyagePlaceDelivery', backend: 'Delivery' },
        { webtrans: 'voyagePlaceReceipt', backend: 'Receipt' },
        { webtrans: 'voyageVoyageNumber', backend: 'Voyage' },
        { webtrans: 'voyageVesselName', backend: 'Vessel' },

        { webtrans: 'freightBLNumber', backend: 'BLNumber' },
        { webtrans: 'freightOriginalCopies', backend: 'NumberOriginal' },
        { webtrans: 'AddressId', backend: 'AddressId' },

        { webtrans: 'id', backend: 'Id' },
    ]

    const BLBookingFields = [
        { webtrans: 'freightBookingNumber', backend: 'BookingNumber' },
        { webtrans: 'freightClientReference', backend: 'ClientReference' },
        { webtrans: 'LocationReceiptId', backend: 'LocationReceiptId' },
        { webtrans: 'LoadingPortId', backend: 'LoadingPortId' },
        { webtrans: 'DischargePortId', backend: 'DischargePortId' },
        { webtrans: 'LocationDeliveryPortId', backend: 'LocationDeliveryPortId' },
        { webtrans: 'Transhipment', backend: 'Transhipment' },
        { webtrans: 'shipperId', backend: 'ShipperId' },
        { webtrans: 'shipperCode', backend: 'ShipperCode' },
        { webtrans: 'consigneeId', backend: 'ConsigneeId' },
        { webtrans: 'consigneeCode', backend: 'ConsigneeCode' },
        { webtrans: 'notifyId', backend: 'NotifyId' },
        { webtrans: 'notifyCode', backend: 'NotifyCode' },
        { webtrans: 'IdBooking', backend: 'Id' },
        { webtrans: 'UserCompanyId', backend: 'UserCompanyId' },
    ]

    const BLAddressFields = [
        { webtrans: 'shipperName', backend: 'ShipperAddress1' },
        { webtrans: 'shipperAddress', backend: 'ShipperAddress2' },
        { webtrans: 'shipperAddress2', backend: 'ShipperAddress3' },
        { webtrans: 'shipperZipCode', backend: 'ShipperAddress4' },
        { webtrans: 'shipperCountry', backend: 'ShipperCity' },
        { webtrans: 'shipperVat', backend: 'ShipperState' },

        { webtrans: 'consigneeName', backend: 'ConsigneeAddress1' },
        { webtrans: 'consigneeAddress', backend: 'ConsigneeAddress2' },
        { webtrans: 'consigneeAddress2', backend: 'ConsigneeAddress3' },
        { webtrans: 'consigneeZipCode', backend: 'ConsigneeAddress4' },
        { webtrans: 'consigneeCountry', backend: 'ConsigneeCity' },
        { webtrans: 'consigneeVat', backend: 'ConsigneeState' },

        { webtrans: 'notifyName', backend: 'NotifyAddress1' },
        { webtrans: 'notifyAddress', backend: 'NotifyAddress2' },
        { webtrans: 'notifyAddress2', backend: 'NotifyAddress3' },
        { webtrans: 'notifyZipCode', backend: 'NotifyAddress4' },
        { webtrans: 'notifyCountry', backend: 'NotifyCity' },
        { webtrans: 'notifyVat', backend: 'NotifyState' },
    ]

    const BLShipmentDetailsFields = [
        { webtrans: 'ShipmentDetailId', backend: 'Id' },
        { webtrans: 'nrPackage', backend: 'Package' },
        { webtrans: 'description', backend: 'Description' },
        { webtrans: 'grossWeight', backend: 'Weight' },
        { webtrans: 'measurements', backend: 'Measures' },
    ]

    const BLShipmentFields = [
        { webtrans: 'ShipmentId', backend: 'Id' },
        { webtrans: 'CommodityCode', backend: 'CommodityCode' },
        { webtrans: 'CommodityName', backend: 'CommodityName' },
        { webtrans: 'IdCommodity', backend: 'IdCommodity' },
        { webtrans: 'IMO', backend: 'IMODangerGoods' },
    ]

    const BLIMOFields = [
        { webtrans: 'IdDangerousGoodsList', backend: 'Id' },
        { webtrans: 'DangerousGoodsId', backend: 'IdDangerousGoods' },
        { webtrans: 'FlashPT', backend: 'FlashPT' },
        { webtrans: 'PackagingGroup', backend: 'PackagingGroup' },
        { webtrans: 'DangerousGoodsCode', backend: 'Code' },
        { webtrans: 'DangerousGoodsClass', backend: 'Class' },
    ]

    const changesFields = ['IdCommodity', 'IMO', 'DangerousGoodsId', 'FlashPT', 'PackagingGroup']

    const customOffice = [
        'Document Type', 'Despatch number', 'Customs office', 'Date'
    ]

    useEffect(() => {
        if (isFirstIteration) {
            ctx.setIsLoad(true)
            sessionStorage.removeItem('blContext')
            sessionStorage.removeItem('operation')
            getSessionStorageData(id)
            setIsFirstIteration(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
        }
        else {
            if (blHTMLCopy) {
                customOfficeFill()
            }
        }
        htmlRefresh()
        // eslint-disable-next-line
    }, [isFirstIteration, blHTMLCopy])

    // eslint-disable-next-line
    useEffect(() => {
        if (sessionStorage.getItem('isPageLoading')) return
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })

        // eslint-disable-next-line
    }, [id, formEntities, formCustomOffice, formShipmentDetails, blSecondHTMLCopy, blHTMLCopy,
        varNameDict, customOfficeDict, dictCustomOfficeDict, showInput, bookingDate, BLDate,
        lines, docSize, pageSize, auxPageSize, organizedData, containerTypes, totalIds,
        shipmentIndex, page, approveDate, containerDate, formPorts, changesTabs, downloadablePDF, listErrors])

    const stateMap = {
    formEntities, formCustomOffice, formShipmentDetails, blHTMLCopy, blSecondHTMLCopy, varNameDict, customOfficeDict, dictCustomOfficeDict,
    showInput, bookingDate, BLDate, lines, docSize, pageSize, auxPageSize, organizedData, containerTypes, totalIds,
    shipmentIndex, page, approveDate, containerDate, formPorts, changesTabs, downloadablePDF, listErrors,
    }

    const sessionStorageMachine = (id, key) => {
        const val = stateMap[key]
        if (val === undefined) return

        if (val instanceof Map) {
            sessionStorage.setItem(`${id}${key}`, JSON.stringify([...val]))
        } else {
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(val))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const safeParse = (key) => {
            const data = sessionStorage.getItem(`${sessionID}${key}`)
            if (data === null || data === undefined || data === "undefined") return null
            try {
                return JSON.parse(data)
            } catch (e) {
                console.error(`Error parsing ${key}:`, e)
                return null
            }
        }

        const frmEntities = safeParse('formEntities')
        const frmCustmsOff = safeParse('formCustomOffice')
        const frmshipDets = safeParse('formShipmentDetails')
        const TempBLHTML = safeParse('blHTMLCopy')
        const TempBlSecondHTML = safeParse('blSecondHTMLCopy')
        const TempVND = safeParse('varNameDict')
        const TempCOD = safeParse('customOfficeDict')
        const TempDCOD = safeParse('dictCustomOfficeDict')
        const TempSI = safeParse('showInput')
        const TempLines = safeParse('lines')
        const TempDS = safeParse('docSize')
        const TempPS = safeParse('pageSize')
        const TempAPS = safeParse('auxPageSize')
        const TempOD = safeParse('organizedData')
        const TempCT = safeParse('containerTypes')
        const TempTIDS = safeParse('totalIds')
        const TempSIndex = safeParse('shipmentIndex')
        const TempBDT = safeParse('bookingDate')
        const TempBLDT = safeParse('BLDate')
        const TempP = safeParse('page')
        const TempAD = safeParse('approveDate')
        const TempCD = safeParse('containerDate')
        const tempFP = safeParse('formPorts')
        const tempCT = safeParse('changesTabs')
        const tempDPDF = safeParse('downloadablePDF')
        const tempLE = safeParse('listErrors')
        if (frmEntities || frmCustmsOff || frmshipDets || TempBLHTML || TempBlSecondHTML ||
            TempVND || TempCOD || TempDCOD || TempSI || TempLines || TempDS || TempPS ||
            TempAPS || TempOD || TempCT || TempTIDS || TempSIndex || TempBDT || TempBLDT ||
            TempP || TempAD || tempFP || tempCT || tempDPDF || tempLE) {
            setBlHTMLCopy(TempBLHTML)
            setBlSecondHTMLCopy(TempBlSecondHTML)
            setFormEntities(frmEntities)
            setFormCustomOffice(frmCustmsOff)
            setFormShipmentDetails(frmshipDets)
            setVarNameDict(new Map(TempVND))
            setCustomOfficeDict(new Map(TempCOD))
            setDictCustomOFficeDict(TempDCOD)
            setShowInput(TempSI)
            setApproveDate(TempAD)
            setContainerDate(TempCD)
            setLines(TempLines)
            setDocSize(TempDS)
            // setPageSize(TempPS)
            // setAuxPageSize(TempAPS)
            setOrganizedData(new Map(TempOD))
            setContainerTypes(TempCT)
            setTotalIds(TempTIDS)
            setShipmentIndex(TempSIndex)
            setBookingDate(TempBDT)
            setBLDate(TempBLDT)
            setPage(TempP)
            setFormPorts(tempFP)
            setChangesTabs(tempCT)
            setDownloadablePDF(tempDPDF)
            setListErrors(tempLE)
            htmlRefresh(false, TempP, new Map(TempOD), new Map(TempVND))
            setTimeout(() => {
                setIsLoaded(false)
                ctx.setIsLoad(false)
            }, 1500)
            return
        }
        get()
    }

    const closeElement = () => {
        setOpenElement(false)
    }

    function toJSONLocal(date) {
        return date.slice(0, 10)
    }

    function reformatDate(dateStr) {
        var dArr = dateStr.split("-")  // ex input: "2010-01-18"
        return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/2010"
    }

    const get = () => {
        setOrganizedData(new Map());
        setContainerTypes([]);
        setVarNameDict(new Map());
        setDictCustomOFficeDict([]);

        let tempValuesMap = new Map()
        let tempChangesInMenus = []
        BLService.getId(lineId).then(dataBL => {
            if (dataBL.name === 'AxiosError') {
                handleTabClose(JSON.parse(id))
                toastMessages('error', dataBL.message, '')
                ctx.setIsLoad(false)
                return
            }

            auditService.getId(lineId).then(audit => {
                const auditMap = new Map(Object.entries(audit)) || new Map()

                const tempBooking = dataBL.Booking
                const tempBL = dataBL.BL
                const tempAddress = dataBL.Address


                errorList.getId(lineId).then(dataErrorList => {
                    if (dataErrorList.name === 'AxiosError') {
                        toastMessages('error', dataErrorList.message, '')
                        handleTabClose(JSON.parse(id))
                        ctx.setIsLoad(false)
                        return
                    }
                    setListErrors(dataErrorList)
                })

                if (tempBooking.CreatedOn !== "") {
                    const tempBookingCreatedOn = reformatDate(toJSONLocal(tempBooking.CreatedOn))
                    setBookingDate(tempBookingCreatedOn)
                }

                if (tempBL.CreatedOn !== "") {
                    const tempBLCreatedOn = reformatDate(toJSONLocal(tempBL.CreatedOn))
                    setBLDate(tempBLCreatedOn)
                }

                if (tempBooking.DateApproved !== "") {
                    const tempApprove = toJSONLocal(tempBooking.DateApproved)
                    setApproveDate(tempApprove)
                }
                if (tempBooking.ContainerInsertedDate && tempBooking.ContainerInsertedDate !== "") {
                    const tempContainerDate = toJSONLocal(tempBooking.ContainerInsertedDate)
                    setContainerDate(tempContainerDate)
                }
                dataBL.ShipmentPlusBLList.sort((a, b) => a.Shipment.Order === b.Shipment.Order ? a.Shipment.TransportKey === b.Shipment.TransportKey : a.Shipment.Order - b.Shipment.Order)
                dataBL.ShipmentPlusBLList.forEach(ship => ship.ShipmentDetailPlusBLList.sort((a, b) => a.ShipmentDetail.Order === b.ShipmentDetail.Order ? a.ShipmentDetail.TransportKey - b.ShipmentDetail.TransportKey : a.ShipmentDetail.Order - b.ShipmentDetail.Order))
                const array = []
                const tempShipments = dataBL.ShipmentPlusBLList
                let tempCustomsOfficeId = []
                const tempCustomOffice = []
                let customIds = 1
                tempShipments.forEach((ships, shipIndex) => {
                    if (ships.CustomsOffice) {
                        if (!tempCustomsOfficeId.includes(ships?.CustomsOffice?.Id)) {
                            tempCustomsOfficeId.push(ships?.CustomsOffice?.Id)
                            const tempObjCustom = {
                                'id': customIds,
                                'Despatch number': ships?.CustomsOffice?.PCOMCustomsDocumentNumber,
                                'Customs office': ships?.CustomsOffice?.PCOMCustomsOffice,
                                'Date': ships?.CustomsOffice?.PCOMCustomsDocumentDate,
                                'idDocumentType': ships?.CustomsOffice?.IdCustomsDocumentType,
                                'idCustomOffice': ships?.CustomsOffice?.Id,
                                'Document Type': ships?.CustomsOffice?.PCOMCustomsDocumentTypeDesc,
                                'shipmentChanged': customsOfficedeRetardLabels(auditMap.get(ships?.CustomsOffice?.Id) || [])
                            }
                            if (tempObjCustom?.shipmentChanged.length && !tempChangesInMenus?.includes('CustomOffice')) {
                                tempChangesInMenus.push('CustomOffice')
                            }
                            tempCustomOffice.push(tempObjCustom)
                            customIds++
                        }
                    }
                    ships.ShipmentDetailPlusBLList.forEach((details, indexDetails) => {

                        const tempShipObj = {
                            'id': indexDetails + 1,
                            'equipmentType': `${details.EquipmentType?.EquipmentTypeLenght ? details.EquipmentType?.EquipmentTypeLenght : ''}${details.EquipmentType?.EquipmentTypeCode ?? ''}`,
                            'prefix': details?.Equipment?.Prefix,
                            'number': details?.Equipment?.Number,
                            'checkDigit': details?.Equipment?.CheckDigit,
                            'sealA': details.BookingEquipment?.SealNumberA || '',
                            'sealB': details.BookingEquipment?.SealNumberB || '',
                            'marks': details.ShipmentDetail.Marks || '',
                            'cargo': [
                                {
                                    'equipmentType': `${details.EquipmentType?.EquipmentTypeLenght ? details.EquipmentType?.EquipmentTypeLenght : ''}${details.EquipmentType?.EquipmentTypeCode ?? ''}`,
                                    'shipment': shipIndex + 1,
                                    'dispatchNumber': ships?.CustomsOffice?.PCOMCustomsDocumentNumber || '',
                                    'CommodityCode': ships?.Shipment?.CommodityCode,
                                    'CommodityName': ships?.Shipment?.CommodityName,
                                    'shipmentId': ships.Id,
                                    'nrPackage': details.ShipmentDetail.Package || '',
                                    'description': details.ShipmentDetail.Description || '',
                                    'grossWeight': details.ShipmentDetail.Weight || '',
                                    'measurements': details.ShipmentDetail.Measures || '',
                                    'IdBookingEquipment': details.ShipmentDetail.IdBookingEquipment,
                                    'IdEquipment': details?.Equipment?.Id || '',
                                    'Prefix': details?.Equipment?.Prefix || '',
                                    'Number': details?.Equipment?.Number || '',
                                    'CheckDigit': details?.Equipment?.CheckDigit || '',
                                    'Payload': details?.Equipment?.Payload || '',
                                    'Tare': details?.Equipment?.Tare || details.EquipmentType?.EquipmentTypeTareWeight,
                                    'OnOff': ships?.Shipment?.Temp !== 0 && ships?.Shipment?.Temp !== undefined && ships?.Shipment?.Temp !== null ? true : false,
                                    'temp': ships?.Shipment?.Temp || '',
                                    'IMO': ships?.Shipment?.IMODangerGoods,
                                    'shipmentChanged': [...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.IdShipment) || [], 'Shipment'), ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.IdBookingEquipment) || [], 'Equipment'), ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.Id) || [], 'ShipmentDetail'), ...ShipmentdeRetardLabels(auditMap.get(ships?.ShipmentCustomsOfficeViewModel?.Id || '') || [], 'CustomsOffice')],
                                    'dangerousGoods': ships?.ShipmentDangerousGoodsPlusBLList.map((imo, imoIndex) => {
                                        return {
                                            'id': imoIndex + 1,
                                            'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                                            'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                                            'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                                            'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                                            'DangerousGoodsCode': imo.DangerousGoods.Code,
                                            'DangerousGoodsClass': imo.DangerousGoods.Class,
                                            'shipmentChanged': IMOdeRetardLabels([...(auditMap.get(imo?.ShipmentDangerousGoods?.Id) || [])]),
                                        }
                                    })
                                },
                            ]
                        }
                        array.push(tempShipObj)
                    })
                })
                setDictCustomOFficeDict(tempCustomOffice)

                fetchHTML().then((data) => {
                    setBlSecondHTML(docTagsServiceRef.current.tagRemoval(data[1]))
                    setBlSecondHTMLCopy(data[1])
                    setBlHTML(docTagsServiceRef.current.tagRemoval(data[0]))
                    setBlHTMLCopy(data[0])
                    tempValuesMap = new Map(docTagsServiceRef.current.getVarNameDict())

                    BLBookingFields.forEach(elem => {
                        if (elem.webtrans === 'Transhipment') {
                            tempValuesMap.set(elem.webtrans, tempBooking[elem.backend] === 'N' || tempBooking[elem.backend] === '' ? false : true)
                        } else {
                            tempValuesMap.set(elem.webtrans, tempBooking[elem.backend] || '')
                        }
                    })

                    BLFields.forEach(elem => {
                        tempValuesMap.set(elem.webtrans, tempBL[elem.backend] || '')
                    })

                    BLAddressFields.forEach(elem => {
                        tempValuesMap.set(elem.webtrans, tempAddress[elem.backend] || '')
                    })

                    tempValuesMap.set('shipmentChanged', BLdeRetardLabels([...(auditMap.get(tempBL.Id) || []), ...(auditMap.get(tempBooking.Id) || []), ...(auditMap.get(tempAddress.Id) || [])]))

                    setVarNameDict(new Map(tempValuesMap))

                    if (portsLocations.some(loc => tempValuesMap.get('shipmentChanged').includes(loc.id))) {
                        tempChangesInMenus.push('Ports')
                    }
                    if (['shipperId', 'consigneeId', 'notifyId'].concat(BLAddressFields).some(adr => tempValuesMap.get('shipmentChanged').includes(adr.webtrans))) {
                        tempChangesInMenus.push('Entities')
                    }


                    // setChangesTabs(tempChangesInMenus)
                })

                let tempId = totalIds
                let tempShipIndex = shipmentIndex
                const tempContainerTypesArray = []
                const tempData = []
                let tempEquipmentIds = 1
                let tempEquipIdsMap = new Map()
                array.forEach((container) => {
                    container.cargo.forEach((cargo) => {
                        let matricula = ''
                        if (!container.prefix && !container.number && !container.checkDigit) {
                            if (tempEquipIdsMap.get(cargo.IdBookingEquipment)) {
                                matricula = tempEquipIdsMap.get(cargo.IdBookingEquipment)
                            } else {
                                matricula = `To Be Filled ${tempEquipmentIds}`
                                tempEquipIdsMap.set(cargo.IdBookingEquipment, matricula)
                                tempEquipmentIds++
                            }
                        } else {
                            matricula = `${container.prefix} ${container.number} ${container.checkDigit} ${container.sealA} ${container.sealB} `
                        }
                        const tempObj = {
                            'id': tempId,
                            'matricula': matricula,
                            'shipment': cargo.shipment,
                            'equipmentType': container.equipmentType,
                            'dispatchNumber': cargo.dispatchNumber,
                            'CommodityCode': cargo.CommodityCode,
                            'CommodityName': cargo.CommodityName,
                            'nrPackage': cargo.nrPackage,
                            'description': cargo.description,
                            'grossWeight': cargo.grossWeight,
                            'measurements': cargo.measurements,
                            'Tare': cargo.Tare,
                            'IMO': cargo.IMO,
                            'Prefix': container.prefix || cargo.Prefix || '',
                            'Number': container.number || cargo.Number || '',
                            'CheckDigit': container.checkDigit || cargo.CheckDigit || '',
                            'Payload': cargo.Payload || '',
                            'IdEquipment': cargo.IdEquipment || '',
                            'onOff': cargo.OnOff || false,
                            'temp': cargo.temp || '',
                            'marks': container.marks || '',
                            'dangerousGoods': cargo.dangerousGoods,
                            'shipmentChanged': cargo.shipmentChanged,
                        }

                        if (tempObj.shipmentChanged?.length > 0 && !tempChangesInMenus?.includes('ShipmentDetails')) {
                            tempChangesInMenus.push('ShipmentDetails')
                        }
                        if (!tempChangesInMenus?.includes('ShipmentDetails') && tempObj?.dangerousGoods?.some(dang => dang?.shipmentChanged?.length > 0)) {
                            tempChangesInMenus.push('ShipmentDetails')
                        }

                        if (!tempContainerTypesArray.includes(tempObj.matricula)) {
                            tempContainerTypesArray.push(tempObj.matricula)
                        }
                        tempShipIndex = tempShipIndex <= tempObj.shipment ? tempObj.shipment : tempShipIndex

                        tempId = tempId + 1
                        tempData.push(tempObj)
                    })
                })
                ProcessStatusService.get().then(dataProcessStatusService => {
                    if (dataProcessStatusService.name === 'AxiosError') {
                        handleTabClose(JSON.parse(id))
                        toastMessages('error', dataProcessStatusService.message, '')
                        ctx.setIsLoad(false)
                        return
                    }
                    dataProcessStatusService.Items.forEach(data2 => {
                        if (data2.StatusName === 'Approved') {
                            if (dataBL?.BL?.ProcessStatusId === data2?.Id) {
                                setDownloadablePDF(true)
                            }
                        }
                    })
                })
                tempShipIndex++
                setShipmentIndex(tempShipIndex)

                tempContainerTypesArray.forEach(type => {
                    const tempObjArray = []
                    tempData.forEach(obj => {
                        if (obj.matricula === type) {
                            tempObjArray.push(obj)
                        }
                    })
                    organizedData.set(type, tempObjArray)
                })

                setTotalIds(tempId)
                const tempOrganize = new Map()
                const tempMap = new Map()

                tempContainerTypesArray.forEach(container => {
                    if (tempMap.get(organizedData.get(container)[0].equipmentType)) {
                        const tempMapArray = tempMap.get(organizedData.get(container)[0].equipmentType)
                        tempMapArray.push({ 'key': container, 'value': organizedData.get(container) })
                    } else {
                        tempMap.set(organizedData.get(container)[0].equipmentType, [{ 'key': container, 'value': organizedData.get(container) }])
                    }
                })
                const tempContainer = []
                tempMap.forEach((value, key) => {
                    value.forEach(obj => {
                        tempOrganize.set(obj.key, obj.value)
                        tempContainer.push(obj.key)
                    })
                })

                // console.log(tempChangesInMenus)
                setChangesTabs(tempChangesInMenus)

                setOrganizedData(new Map(tempOrganize))
                setContainerTypes(tempContainer)
                htmlRefresh()
                setTimeout(() => {
                    setIsLoaded(false)
                    ctx.setIsLoad(false)
                }, 1500)
            })
        })
    }

    const BLdeRetardLabels = (newList) => {
        const tempList = []
        newList.forEach(el => {
            BLFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
            BLBookingFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
            BLAddressFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
        })
        return tempList
    }

    const ShipmentdeRetardLabels = (newList, type) => {
        const tempList = []
        newList.forEach(el => {
            if (type === 'ShipmentDetail') {
                BLShipmentDetailsFields.forEach(elem => {
                    if (elem.backend === el) {
                        tempList.push(elem.webtrans)
                    }
                })
            }
            if (type === 'Shipment') {
                BLShipmentFields.forEach(elem => {
                    if (elem.backend === el) {
                        tempList.push(elem.webtrans)
                    }
                })
            }
            if (type === 'CustomsOffice') {
                if (el === 'CustomsOfficeId') {
                    tempList.push('shipmentDispatch')
                }
            }
        })
        return tempList
    }

    const IMOdeRetardLabels = (newList) => {
        const tempList = []
        newList.forEach(el => {
            BLIMOFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
        })
        return tempList
    }

    const customsOfficedeRetardLabels = (newList) => {
        const tempList = []
        newList.forEach(el => {
            BLCustomsOfficeFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
        })
        return tempList
    }

    const customOfficeFill = () => {
        customOffice.forEach((elem) => {
            customOfficeDict.set(elem, '')
            setCustomOfficeDict(new Map(customOfficeDict))
        })
    }

    const fetchHTML = async () => {
        const tempData = await (await fetch('/bl/figma_htmlgenerator/BL_NAIP.html')).text()
        const tempSecondData = await (await fetch('/bl/figma_htmlgenerator/blSecondPage.html')).text()
        return [tempData, tempSecondData]
    }

    const OGData = useMemo(() => {
        const result = []
        containerTypes.forEach(container => {
            organizedData?.get(container)?.forEach(obj => {
                result.push(obj)
            })
        })
        return result
    }, [organizedData, containerTypes])

    const htmlRefresh = useCallback((
        passBol,
        tempPage,
        sentData,
        passData
    ) => {
        let tempBLCopy = blHTMLCopy
        let tempBL2Copy = blSecondHTMLCopy

        const bol = passBol ?? showInput
        const newPage = tempPage ?? page
        const dataValues = passData ?? varNameDict

        dataValues.set('freightOriginalCopies', docSize)

        const tempData = docTagsServiceRef.current.updateDoc(
            tempBLCopy,
            dataValues,
            OGData,
            bol,
            1,
            pageSize,
            auxPageSize,
            docSize
        )

        if (!tempData) return

        let tempSecondData

        if (tempData[1] >= pageSize) {
            setVarNameDict(new Map(dataValues.set('blPage', newPage - 1)))

            tempSecondData = docTagsServiceRef.current.updateDoc(
                tempBL2Copy,
                dataValues,
                OGData,
                bol,
                newPage,
                pageSize,
                auxPageSize,
                docSize
            )

            if (tempSecondData[1] >= auxPageSize) {
                let tempLines = tempSecondData[1]
                let totalPages = 0
                while (tempLines >= 0) {
                    tempLines -= auxPageSize
                    totalPages++
                }
                const newDocSize = totalPages + 1
                setDocSize(newDocSize)
                dataValues.set('freightOriginalCopies', newDocSize)
            }

            setLines(tempSecondData[1])
            setBlSecondHTML(tempSecondData[0])
        } else {
            setLines(tempData[1])
        }

        setBlHTML(tempData[0])

        return newPage === 1 ? tempData[0] : tempSecondData?.[0]
    }, [
        OGData,
        blHTMLCopy,
        blSecondHTMLCopy,
        showInput,
        page,
        varNameDict,
        pageSize,
        auxPageSize,
        docSize
    ])


    const inputChanged = (key, value) => {
        if (typeof value === 'string') {
            value = value.toUpperCase()
        }

        setVarNameDict(prev => {
            const newMap = new Map(prev)
            newMap.set(key, value)
            htmlRefresh(null, null, null, newMap)
            return newMap
        })
    }

    const showForm = (n) => {
        switch (n) {
            case 1:
                setFormEntities(true)
                setFormCustomOffice(false)
                setFormShipmentDetails(false)
                setFormPorts(false)
                break
            case 2:
                setFormEntities(false)
                setFormCustomOffice(true)
                setFormShipmentDetails(false)
                setFormPorts(false)
                break
            case 3:
                setFormEntities(false)
                setFormCustomOffice(false)
                setFormShipmentDetails(true)
                setFormPorts(false)
                break
            case 4:
                setFormEntities(false)
                setFormCustomOffice(false)
                setFormShipmentDetails(false)
                setFormPorts(true)
                break
            default:
                return null
        }
    }

    const columns = ["nrPackage", "description", "grossWeight", "measurements"]

    const headerBody = (e, col) => {
        if (col === 'grossWeight') {
            col = 'Gross Weight'
        }
        if (col === 'measurements') {
            col = 'Measures'
        }
        return col
    }

    const containerColumns = columns.map(col => {
        if (matches) {
            return <Column
                className='tableShipmentColumn'
                key={col}
                style={col === 'description' ?
                    {
                        'minWidth': '280px',
                        'maxWidth': '280px'
                    } :
                    {
                        'minWidth': '90px',
                        'maxWidth': '90px'
                    }}
                columnKey={col}
                header={(e) => headerBody(e, col)}
                headerStyle={{
                    borderBottom: `2px solid ${ctx.primaryColor}`,
                    backgroundColor: 'var(--color-white)',
                    color: ctx.secondaryColor,
                    width: 'auto'
                }}
                body={(e) => cellBody(e, col)}
            />
        } else {
            return <Column
                className='tableShipmentColumn'
                key={col}
                columnKey={col}
                header={col}
                headerStyle={{
                    borderBottom: `2px solid ${ctx.primaryColor}`,
                    color: ctx.secondaryColor,
                    backgroundColor: 'var(--color-white)',
                    width: 'auto'
                }}
                body={(e) => cellBody(e, col)}
            />
        }
    })

    const header = (data) => {
        return (
            <span
                className="image-text headerStyle"
                style={{
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    flexWrap: 'nowrap'
                }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div><b style={{ color: 'var(--color-blue)' }}>{data}</b></div>
                </div>
                <b>{organizedData.get(data)[0].equipmentType}</b>
            </span>
        )
    }

    const checkShipmentChanges = (data) => {
        if (data?.shipmentChanged?.some(field => changesFields.includes(field))) {
            return true
        }
        data?.dangerousGoods?.some(obj => obj?.shipmentChanged?.some(field => changesFields?.includes(field)))
    }

    const subHeader = (data) => {
        let tempValues = []
        let tempIsIn = false
        organizedData.get(data.matricula).forEach(obj => {
            if (tempIsIn) {
                if (obj.shipment !== data.shipment) {
                    tempIsIn = false
                } else {
                    tempValues.push(obj)
                }
            }
            if (obj.id === data.id) {
                tempIsIn = true
                tempValues.push(obj)
            }
        })
        let tempBol
        tempValues.length > 1 ? tempBol = tempValues.length : tempBol = 0
        return (
            <div
                className='subHeaderContainer'
                style={{
                    border: data?.shipmentChanged?.includes('ShipmentId') ? '2px solid var(--color-green)' : '0px solid White',
                    borderRadius: '5px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: ((33 * tempBol) - 37) / 2,
                    paddingBottom: ((33 * tempBol) - 37) / 2,
                    margin: '5px'
                }}>
                <div className='cursorDefault' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '65px', minWidth: '115px' }}>
                    <div className='image-text'>Shipment {data.shipment}</div>
                    <Settings
                        className={' cursorPointer'}
                        style={{
                            color: checkShipmentChanges(data) && !data.shipmentChanged.includes('ShipmentId') ? 'var(--color-yellow)' : data.dispatchNumber === "" ? 'var(--color-blue)' : 'var(--color-green)',
                            transform: 'scale(.65)'
                        }}
                        onClick={() => {
                            setShipmentToDispatch(data)
                            setOpenElement(true)
                        }} />
                    {/* <div className='dispatchDisplay' style={{ marginTop: '18px', fontSize: '13px', maxWidth: '108px' }}>{data?.dispatchNumber || ''}</div> */}
                    <div className='dispatchDisplay' style={{ fontSize: '13px', maxWidth: '108px' }}>{data?.dispatchNumber || ''}</div>
                </div>
            </div>
        )
    }

    const cellBody = (row, field) => {
        if (row[field] !== null) {
            return <div
                className={'inputColumnsContainer'}
                style={row?.shipmentChanged?.includes('ShipmentDetailId') && !row?.shipmentChanged?.includes('ShipmentId') ?
                    {
                        borderTop: '2px solid var(--color-green)',
                        borderBottom: '2px solid var(--color-green)',
                        borderLeft: field === 'nrPackage' && '2px solid var(--color-green)',
                        borderTopLeftRadius: field === 'nrPackage' && '5px',
                        borderBottomLeftRadius: field === 'nrPackage' && '5px',
                        borderRight: field === 'measurements' && '2px solid var(--color-green)',
                        borderTopRightRadius: field === 'measurements' && '5px',
                        borderBottomRightRadius: field === 'measurements' && '5px',
                        height: '100%',
                    } : {}}
            >
                <MInputTextField
                    margin={'7px'}
                    padding={'0px'}
                    paddingLeft={'5px'}
                    height={'26px'}
                    size={field === 'nrPackage' ? '90px' : field === 'grossWeight' || field === 'measurements' ? '80px' : '280px'}
                    value={row[field]}
                    disabled
                    color={row?.shipmentChanged?.includes(field) && !row.shipmentChanged.includes('ShipmentDetailId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                    disabledColor={row?.shipmentChanged?.includes(field) && !row.shipmentChanged.includes('ShipmentDetailId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                >
                </MInputTextField>
            </div>
        } else {
            return <div
                className={'inputColumnsContainer'}
                style={row?.shipmentChanged?.includes('ShipmentDetailId') && !row?.shipmentChanged?.includes('ShipmentId') ?
                    {
                        borderTop: '2px solid var(--color-green)',
                        borderBottom: '2px solid var(--color-green)',
                        borderLeft: '2px solid var(--color-green)',
                        borderTopLeftRadius: '5px',
                        borderBottomLeftRadius: '5px',
                        height: '100%',
                    } : {}}
            >
                <MInputTextField
                    margin={'7px'}
                    padding={'0px'}
                    paddingLeft={'5px'}
                    height={'26px'}
                    size={'80px'}
                    color={row?.shipmentChanged?.includes(field) && !row.shipmentChanged.includes('ShipmentDetailId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                    disabledColor={row?.shipmentChanged?.includes(field) && !row.shipmentChanged.includes('ShipmentDetailId') ? 'var(--color-yellow)' : 'var(--color-white)'}
                    style={{ cursor: 'default' }}
                    disabled
                    value={row[field]}
                >
                </MInputTextField>
            </div>
        }
    }

    const [pdfs, setPdfs] = useState([])
    const [tempPage, setTempPage] = useState(1)

    const mergePDF = useCallback(async (files) => {
        const mergedPdf = await PDFDocument.create();

        for (const file of files) {
            const pdf = await PDFDocument.load(file);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            pages.forEach((page) => mergedPdf.addPage(page));
        }
        const mergedPdfFile = await mergedPdf.save();

        setTempPage(1)
        setPdfs([])
        setPage(1)

        download(mergedPdfFile, `${varNameDict.get('freightBookingNumber')}-BL.pdf`,"application/pdf")

        ctx.setIsLoad(false)
    }, [varNameDict, ctx])

    const blobs = useCallback(() => {
        const blobsArray = pdfs
        const files = new Array(blobsArray.length);
        let loadedCount = 0;

        blobsArray.forEach((blob, i) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = () => {
                files[i] = reader.result;
                loadedCount++;
                if (loadedCount === blobsArray.length) {
                    mergePDF(files);
                }
            };
        });
    }, [pdfs, mergePDF])

    const blHtmlDownload = useCallback((passPage) => {
        ctx.setIsLoad(true)
        toastMessages('success', 'Generating PDF', '')
        let doc
        setPage(passPage)

        doc = new jsPDF({
            format: "a0",
            unit: "px"
        })
        doc.setFont("Courier", "normal")

        let newHTML = htmlRefresh(showInput, passPage)

        let tempPdf
        doc.html(newHTML, {
            callback: (doc) => {
                tempPdf = doc.output('blob')
                setPdfs(prev => [...prev, tempPdf])
                doc = new jsPDF()
            },
            html2canvas: {
                onclone: (_doc) => document.fonts.ready 
            }
        })
    }, [ctx, toastMessages, showInput, htmlRefresh])

    useEffect(() => {
        if (pdfs.length === 0) return
        if (!isFirstIteration) {
            if (lines >= pageSize && tempPage < docSize) {
                const tempPageIndex = tempPage + 1
                setTempPage(tempPageIndex)
                blHtmlDownload(tempPageIndex)
                return
            }
            if (tempPage === docSize || (docSize === 2 && lines < pageSize)) {
                blobs()
            }
        }
        // eslint-disable-next-line
    }, [pdfs])

    const element = () => {
        return (
            <>
                <div className='titleDrawer'>
                    <h1>Shipment Options</h1>
                </div>

                <fieldset style={{ borderColor: 'grey' }}>
                    <legend style={{ color: 'grey' }}>Despatch Number</legend>
                    <MSelect
                        label={'Despatch Number'}
                        value={shipmentToDispatch?.dispatchNumber || ''}
                        options={dictCustomOfficeDict.map(el => { return { label: `#${el.id} Despatch - ${el['Despatch number']}`, value: el['Despatch number'] } })}
                        disabled
                        color={shipmentToDispatch?.shipmentChanged?.includes('shipmentDispatch') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                        disabledColor={shipmentToDispatch?.shipmentChanged?.includes('shipmentDispatch') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                    />

                </fieldset>
                <fieldset style={{ borderColor: 'grey' }}>
                    <legend style={{ color: 'grey' }}>Commmodity</legend>
                    <div className="divTextfields">
                        {Commmodity.map((value, index) => (
                            value.label === 'Code' ?
                                <MInputTextField
                                    key={index}
                                    label={value.label}
                                    value={shipmentToDispatch?.CommodityCode || ''}
                                    disabled
                                    color={shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    disabledColor={shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                />
                                :
                                <div key={index} className="individualTextfield">
                                    <MInputTextField
                                        key={index}
                                        label={value.label}
                                        value={shipmentToDispatch?.CommodityName || ''}
                                        disabled
                                        color={shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        disabledColor={shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    />
                                </div>
                        ))}
                    </div>
                </fieldset>
                <fieldset style={{ position: 'relative', borderColor: 'grey' }}>
                    <legend style={{ color: 'grey' }}>IMO</legend>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <MCheckBox
                            checked={shipmentToDispatch?.IMO}
                            label={'IMO'}
                            disabled={true}
                            onChange={(e) => { setShipmentToDispatch({ ...shipmentToDispatch, 'IMO': e.target.checked }) }}
                            color={shipmentToDispatch?.shipmentChanged?.includes('IMO') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                        />
                    </div>
                    {shipmentToDispatch?.IMO ? (
                        (shipmentToDispatch?.dangerousGoods && shipmentToDispatch?.dangerousGoods.length > 0) ?
                            shipmentToDispatch.dangerousGoods.map((imo, imoIndex) => (

                                <fieldset key={imoIndex} style={{ borderColor: 'grey' }}>
                                    <legend style={{ color: 'grey' }}>Dangerous Goods {imo.id || ''}</legend>
                                    <div className="divTextfields">
                                        {DangerousGoods.map((value, index) => (
                                            <div key={index}>
                                                {value.label === 'UN No.' || value.label === 'Class' ?
                                                    <div className="individualTextfield">
                                                        <MInputTextField
                                                            disabled
                                                            label={<span style={{ color: 'grey' }}>{value.label}</span>}
                                                            value={imo[value.code] || ''}
                                                            color={imo?.shipmentChanged?.includes(`DangerousGoodsId`) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                            disabledColor={imo?.shipmentChanged?.includes(`DangerousGoodsId`) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : 'grey'}
                                                        />
                                                    </div>
                                                    :
                                                    <div className="individualTextfield">
                                                        <MInputTextField
                                                            disabled
                                                            label={value.label}
                                                            value={imo[value.code] || ''}
                                                            color={imo?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                            disabledColor={imo?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </fieldset>
                            ))
                            :
                            (
                                <fieldset style={{ borderColor: 'grey' }}>
                                    <legend style={{ color: 'grey' }}>Dangerous Goods 1</legend>
                                    <div className="divTextfields">
                                        {DangerousGoods.map((value, index) => (
                                            <div key={index} className="individualTextfield">
                                                <MInputTextField
                                                    disabled
                                                    label={value.label === 'UN No.' || value.label === 'Class' ? <span style={{ color: 'grey' }}>{value.label}</span> : value.label}
                                                    value={''}
                                                    disabledColor={'grey'}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </fieldset>
                            )
                    ) : (
                        (shipmentToDispatch?.dangerousGoods && shipmentToDispatch?.dangerousGoods.length > 0) ?
                            shipmentToDispatch.dangerousGoods.map((imo, imoIndex) => (
                                <fieldset key={imoIndex} style={{ borderColor: 'grey' }}>
                                    <legend style={{ color: 'grey' }}>Dangerous Goods</legend>
                                    <div className="divTextfields">
                                        {DangerousGoods.map((value, index) => (
                                            <div key={index} className="individualTextfield">
                                                <MInputTextField
                                                    disabled
                                                    label={value.label}
                                                    value={' '}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </fieldset>
                            )) : null
                    )}
                </fieldset>

                <fieldset style={{ borderColor: 'grey' }}>
                    <legend style={{ color: 'grey' }}>SOC</legend>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', textAlign: 'center' }}>
                        <div className="individualTextfield">
                            <MInputTextField
                                label={'Prefix'}
                                value={shipmentToDispatch?.Prefix || ''}
                                disabled
                                color={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                disabledColor={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                        <div className="individualTextfield">
                            <MInputTextField
                                label={'Number'}
                                value={shipmentToDispatch?.Number || ''}
                                disabled
                                color={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                disabledColor={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                        <div className="individualTextfield">
                            <MInputTextField
                                label={'Check Digit'}
                                value={shipmentToDispatch?.CheckDigit || ''}
                                disabled
                                color={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                disabledColor={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                    </div>
                    <div className="divTextfields">
                        <div className="individualTextfield">
                            <MInputTextField
                                type={'number'}
                                label={'Payload'}
                                value={shipmentToDispatch?.Payload || ''}
                                disabled
                                color={shipmentToDispatch?.shipmentChanged?.includes('Payload') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                disabledColor={shipmentToDispatch?.shipmentChanged?.includes('Payload') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                        <div className="individualTextfield">
                            <MInputTextField
                                type={'number'}
                                label={'Tare(KG)'}
                                value={shipmentToDispatch?.Tare || ''}
                                disabled
                                color={shipmentToDispatch?.shipmentChanged?.includes('Tare') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                disabledColor={shipmentToDispatch?.shipmentChanged?.includes('Tare') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset style={{ borderColor: 'grey' }}>
                    <legend style={{ color: 'grey' }}>Reefer</legend>
                    <div className="divTextfields">
                        <div className="individualTextfield">
                            <MSwitchButton
                                checked={shipmentToDispatch?.onOff !== undefined && shipmentToDispatch?.onOff !== null ? shipmentToDispatch?.onOff : false}
                                disabled
                                secondColor={shipmentToDispatch?.shipmentChanged?.includes('onOff') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                color={shipmentToDispatch?.shipmentChanged?.includes('onOff') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                            On/Off
                        </div>
                        <div className="individualTextfield">
                            <MInputTextField
                                type={'number'}
                                label={'Temperature'}
                                value={shipmentToDispatch?.temp || ''}
                                disabled
                                secondColor={shipmentToDispatch?.shipmentChanged?.includes('temp') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                color={shipmentToDispatch?.shipmentChanged?.includes('temp') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                    </div>
                </fieldset>
                <fieldset style={{ borderColor: 'grey' }}>
                    <legend style={{ color: 'grey' }}>Marks</legend>
                    <div className="divTextfields">
                        <div style={{ width: '100%', gridColumn: '1 / -1' }}>
                            <MTextArea
                                label={'Marks'}
                                value={shipmentToDispatch?.marks || ''}
                                disabled
                                rows={3}
                                color={shipmentToDispatch?.shipmentChanged?.includes('marks') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                disabledColor={shipmentToDispatch?.shipmentChanged?.includes('marks') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            />
                        </div>
                    </div>
                </fieldset>
            </>
        )
    }

    const functionLeavingPage = () => {
        ctx2.closeTab(JSON.parse(id))
    }

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (
                <>
                    <MHeader
                        element={
                            <>
                                <MButton
                                    tooltip={t("Back")}
                                    label={t("Back")}
                                    icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                                    onClick={() => { setLeavingPage(true) }}
                                />

                                {listErrors.ErrorMessage ? (
                                    <MButton
                                        tooltip={t("SeeErrors")}
                                        label={t("SeeErrors")}
                                        icon={<i className="pi pi-info iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                        onClick={() => setOpenModalSeeErrors(true)}
                                    />
                                ) : null}
                            </>
                        }
                    />
                    <div className='principalDivTimeline'>
                        <div className='divTimeline'>
                            <MTimeLine valueTimeline={valueTimeline} color={'var(--color-blue)'} />
                        </div>
                    </div>
                    <div className='containerBL'>
                        <Splitter style={{ width: '100vw', background: 'transparent', border: '0px solid' }} onResizeEnd={(e) => setSeparator(e.sizes)}>
                            <SplitterPanel size={separator[0]}>
                                <div className='formBL'>
                                    <div className='divCards' >
                                        <MTabsInpage
                                            type={"buttons"}
                                            firstTabOpen={formEntities ? 2 : formCustomOffice ? 3 : formShipmentDetails ? 4 : formPorts ? 1 : 2}
                                            renderTabs={cards.map(obj => {
                                                return {
                                                    iconTab: obj.icon,
                                                    labelTab: obj.name,
                                                    id: obj.id,
                                                    color: changesTabs?.includes(obj.code) ? 'var(--color-yellow)' : ''
                                                }
                                            })}
                                            onGetTab={(e) => {
                                                showForm(e.id)
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                        <h4 style={{ margin: '0' }}>Booking Number: &nbsp; </h4> <h2 > {varNameDict.get('freightBookingNumber')}</h2>
                                    </div>
                                    {formPorts &&
                                        <MFieldset
                                            labelInside
                                            label={t("Ports")}
                                            elements={
                                                <div className='divFormsBl' style={{ minWidth: '712px' }}>
                                                    <div className='displayGridBl'>
                                                        {portsLocations.map((value, index) => (
                                                            value.type === "textfield" ?
                                                                (<div className="textfieldBl" style={{ display: 'flex' }} key={index} >
                                                                    <MInputTextField
                                                                        label={value.label}
                                                                        disabled
                                                                        value={varNameDict.get(value.code) || ''}
                                                                        color={varNameDict.get('shipmentChanged')?.includes(value.id) ? 'var(--color-yellow)' : undefined}
                                                                        disabledColor={varNameDict.get('shipmentChanged')?.includes(value.id) ? 'var(--color-yellow)' : undefined}
                                                                    />
                                                                </div>)
                                                                : value.type === "checkbox" ?
                                                                    <div className='checkbox textfield paddingLeft' key={index}>
                                                                        {value.label === "Transhipment" ?
                                                                            <>
                                                                                <MCheckBox
                                                                                    disabled={true}
                                                                                    checked={varNameDict.get(value.code) === undefined || varNameDict.get(value.code) === null ? false : varNameDict.get(value.code)}
                                                                                    label={value.label}
                                                                                    color={varNameDict.get('shipmentChanged')?.includes('Transhipment') ? 'var(--color-yellow)' : undefined}
                                                                                />
                                                                            </>
                                                                            : <MCheckBox />
                                                                        }
                                                                        {/* <p style={varNameDict.get('shipmentChanged')?.includes('Transhipment') ? { color: 'var(--color-yellow)' } : { color: 'grey' }} className='textCheckbox' >{value.label}</p> */}
                                                                    </div>
                                                                    :
                                                                    ""
                                                        ))}
                                                    </div>
                                                </div>
                                            } />}
                                    {formEntities ?
                                        <div style={{ minWidth: '712px' }}>
                                            {entityLabels.map((entity, index) => (
                                                <div style={{ marginBottom: '20px', }} key={index}>
                                                    <MFieldset
                                                        labelInside
                                                        label={entity.label}
                                                        headerElement={
                                                            <div className='divEntityMiddleButton' style={{ marginRight: '10px' }}>
                                                                <div style={{ marginLeft: '20px', marginRight: '10px', marginTop: '10px' }}>
                                                                    <MInputTextField
                                                                        label={`${entity.label} Account`}
                                                                        disabled
                                                                        value={varNameDict.get(`${entity.label.toLowerCase()}Code`) || ''}
                                                                        onChange={(e) => { }}
                                                                        color={varNameDict.get('shipmentChanged')?.includes(`${entity.label.toLowerCase()}Id`) ? 'var(--color-yellow)' : undefined}
                                                                        disabledColor={varNameDict.get('shipmentChanged')?.includes(`${entity.label.toLowerCase()}Id`) ? 'var(--color-yellow)' : undefined}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        elements={
                                                            <div className='displayGridBl'>
                                                                {entity.fields.map((name, i) => {
                                                                    const tempName = entity.label.toLowerCase().concat(name)
                                                                    return (
                                                                        <div key={i} className="textfieldBl">
                                                                            <MInputTextField
                                                                                label={name}
                                                                                disabled
                                                                                value={varNameDict.get(tempName) || ''}
                                                                                onChange={(e) => inputChanged(tempName, e.target.value)}
                                                                                color={varNameDict.get('shipmentChanged')?.includes(tempName) ? 'var(--color-yellow)' : undefined}
                                                                                disabledColor={varNameDict.get('shipmentChanged')?.includes(tempName) ? 'var(--color-yellow)' : undefined}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        } />
                                                </div>
                                            ))}
                                        </div>
                                        : null
                                    }
                                    {formCustomOffice ?
                                        <MFieldset
                                            label={"Customs Office"}
                                            labelInside
                                            elements={
                                                <TableCustomOffice dictCustomOfficeDict={dictCustomOfficeDict} />
                                            } />
                                        : null
                                    }
                                    {formShipmentDetails ?
                                        <MFieldset
                                            labelInside
                                            elements={
                                                containerTypes.map((container, index) => (
                                                    <DataTable
                                                        key={index}
                                                        tabIndex={index}
                                                        header={() => header(container)}
                                                        size="small"
                                                        value={organizedData.get(container)}
                                                        rowGroupMode="rowspan"
                                                        groupRowsBy="shipment"
                                                        sortOrder={1}
                                                        sortField={"matricula"}
                                                        responsiveLayout="stack"
                                                        breakpoint="0px"
                                                        className='BLTable'
                                                    >
                                                        <Column
                                                            className='shipmentName'
                                                            field='shipment'
                                                            header={'Shipment'}
                                                            body={subHeader}
                                                            headerStyle={{
                                                                borderBottom: `2px solid ${ctx.primaryColor}`,
                                                                color: ctx.secondaryColor
                                                            }} />
                                                        {containerColumns}
                                                    </DataTable>
                                                ))
                                            } />
                                        : null
                                    }
                                </div>
                            </SplitterPanel>
                            <SplitterPanel size={separator[1]}>
                                <MFieldset
                                    labelInside
                                    elements={
                                        <div className='renderContainer'>
                                            <div style={{ display: 'flex', zIndex: '1200', width: '100%', position: 'absolute', top: '0' }}>
                                                <MHeader
                                                    notsticky
                                                    element={
                                                        <>
                                                            <MButton
                                                                label={t("LabelZoomIn")}
                                                                tooltip={t("LabelZoomIn")}
                                                                icon={<ZoomInIcon color='info' />}
                                                                onClick={() => {
                                                                    if (zoom === 90) {
                                                                        return
                                                                    } else {
                                                                        setZoom(prev => prev + 10)
                                                                    }
                                                                }}
                                                            />
                                                            <MButton
                                                                label={t("LabelZoomOut")}
                                                                tooltip={t("LabelZoomOut")}
                                                                icon={<ZoomOutIcon color='info' />}
                                                                onClick={() => {
                                                                    if (zoom === 20) {
                                                                        return
                                                                    }
                                                                    else {
                                                                        setZoom(prev => prev - 10)
                                                                    }
                                                                }}
                                                            />
                                                            {downloadablePDF && (
                                                                <MButton
                                                                    label={t("LabelDownloadDraft")}
                                                                    tooltip={t("LabelDownloadDraft")}
                                                                    icon={<DownloadIcon color='info' />}
                                                                    onClick={() => { blHtmlDownload(1) }}
                                                                />
                                                            )}
                                                        </>
                                                    }
                                                />
                                            </div>
                                            <span className='render' style={{ transform: `scale(${zoom}%)`, overflow: 'auto!important' }}>
                                                <Draggable >
                                                    {page === 1 ?
                                                        <div className='render' style={{ transform: `scale(${zoom}%)` }} dangerouslySetInnerHTML={{ __html: blHTML }}></div>
                                                        :
                                                        <div className='render' style={{ transform: `scale(${zoom}%)` }} dangerouslySetInnerHTML={{ __html: blSecondHTML }}></div>
                                                    }
                                                </Draggable>
                                            </span>
                                            <div style={{
                                                position: 'absolute',
                                                zIndex: '111',
                                                bottom: '0',
                                                display: 'flex',
                                                width: '100%',
                                                justifyContent: 'center',
                                            }}>
                                                {
                                                    lines >= pageSize ?
                                                        <>
                                                            <MButton
                                                                none
                                                                tooltip={t("LabelPreviousPage")}
                                                                icon={<ArrowForwardIosSharpIcon sx={{ transform: 'rotate(180deg)' }} color='info' />}
                                                                onClick={() => {
                                                                    const tempPage = page === 1 ? page : page - 1
                                                                    htmlRefresh(showInput, tempPage)
                                                                    setPage(tempPage)
                                                                }}
                                                            />
                                                            <span style={{ color: 'var(--color-blue)', scale: '1.5', marginTop: '8px' }}>
                                                                {page}
                                                            </span>
                                                            <MButton
                                                                none
                                                                tooltip={t("LabelNextPage")}
                                                                icon={<ArrowForwardIosSharpIcon color='info' />}
                                                                onClick={() => {
                                                                    const tempPage = page === docSize ? page : page + 1
                                                                    htmlRefresh(showInput, tempPage)
                                                                    setPage(tempPage)
                                                                }}
                                                            />
                                                        </>
                                                        : ''
                                                }
                                            </div>
                                        </div>
                                    } />
                                <MElementDrawer
                                    open={openElement}
                                    setOpen={setOpenElement}
                                    onClose={closeElement}
                                    element={element()}
                                />
                                <MMessageBoard
                                    warning
                                    open={leavingPage}
                                    onClose={functionLeavingPage}
                                    title={t("leavingPageTitle")}
                                    body={t("leavingPageBody")}
                                    footer={
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <MButton hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                                            <MButton hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
                                        </span>
                                    }
                                />
                            </SplitterPanel>
                        </Splitter >
                    </div >

                    {/* MODAL SE ERRORS */}
                    <MMessageBoard
                        open={OpenModalSeeErrors}
                        minWidth={'30%'}
                        onClose={() => setOpenModalSeeErrors(false)}
                        title={t("ListErrors")}
                        body={
                            <span>
                                <b>{listErrors.CreatedOn}</b>: {listErrors.ErrorMessage}
                            </span>
                        }
                        footer={
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <MButton hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setOpenModalSeeErrors(false)} label={t("ButtonCancel")} />
                            </span>
                        }
                    />
                    <br /><br /><br /><br /><br />
                </>
            )
            }
        </>
    )
}

